"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Option = exports.Options = exports.OptionListWrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var OptionListWrapper = _styled.default.div(function (_ref) {
  var _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      space = _ref$theme.space;
  return {
    width: '100%',
    height: 'auto',
    padding: space.large,
    backgroundColor: colors.greydark
  };
});

exports.OptionListWrapper = OptionListWrapper;

var Options = _styled.default.ul(function () {
  return {
    height: '100%',
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'start'
  };
});

exports.Options = Options;

var Option = _styled.default.li(function (_ref2) {
  var _ref3;

  var _ref2$theme = _ref2.theme,
      space = _ref2$theme.space,
      mediaQueries = _ref2$theme.mediaQueries;
  return _ref3 = {
    padding: 0,
    marginBottom: space.base,
    color: 'white',
    width: '50%',
    display: 'flex'
  }, _defineProperty(_ref3, mediaQueries.medium, {
    width: '33%'
  }), _defineProperty(_ref3, mediaQueries.large, {
    width: '25%'
  }), _ref3;
});

exports.Option = Option;